import React from "react";
import "./GigCard.scss";
import { Link } from "react-router-dom";
import newRequest from "../../utils/newRequest";
import { useQuery } from "@tanstack/react-query";

const GigCard = ({ item }) => {
  //fetch the data
  const { isLoading, error, data } = useQuery({
    queryKey: ["item.userId"],
    queryFn: () =>
      newRequest.get(`/users/${item.userId}`).then((res) => {
        return res.data;
      }),
  });

  return (
    <Link className="link" to={`/gig/${item?._id}`}>
      <div className="gigcard">
        <img src={item?.cover} alt="" />
        <div className="info">
          {isLoading ? (
            "Loading..."
          ) : error ? (
            "Something went wrong !"
          ) : (
            <div className="user">
              <img src={data?.img || "img/noavatar.jpg"} alt="userPhoto" />
              {data?.username}
            </div>
          )}
          <p>{item?.desc}</p>
          <div className="star">
            <img src="./img/star.png" alt="" />
            <span>
              {!isNaN(item?.totalStars / item?.starNumber) &&
                Math.round(item?.totalStars / item?.starNumber)}
            </span>
          </div>
        </div>
        <hr />
        <div className="detail">
          <img src="./img/heart.png" alt="" />
          <div className="price">
            <span>STARTING AT</span>
            <h2>$ {item?.price}</h2>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default GigCard;
